var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinishedcourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M-10 40C-10 62.1 7.9 80 30 80L30 40L-10 40Z",
    fill: "#B0BEC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M30 80C52.1 80 70 62.1 70 40L30 40L30 80Z",
    fill: "#B0BEC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M70 40C70 17.9 52.1 6.66337e-06 30 7.62939e-06L30 40L70 40Z",
    fill: "#B0BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30 3.8147e-06C7.90001 1.88265e-06 -9.99999 17.9 -9.99999 40L30 40L30 3.8147e-06Z",
    fill: "#B0BEC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 46.6875L38.6875 53.3125L34 48.6875L36 46.6875L38.6875 49.3125L43.3125 44.6875L45.3125 46.6875ZM31.4375 50.5625C31.1042 50.6458 30.625 50.6875 30 50.6875C28.0833 50.6875 26.2917 50.2083 24.625 49.25C23 48.2917 21.7083 47 20.75 45.375C19.7917 43.7083 19.3125 41.9167 19.3125 40C19.3125 38.0833 19.7917 36.3125 20.75 34.6875C21.7083 33.0208 23 31.7083 24.625 30.75C26.2917 29.7917 28.0833 29.3125 30 29.3125C31.9167 29.3125 33.6875 29.7917 35.3125 30.75C36.9792 31.7083 38.2917 33.0208 39.25 34.6875C40.2083 36.3125 40.6875 38.0833 40.6875 40C40.6875 40.625 40.6458 41.1042 40.5625 41.4375C41.3958 41.5625 42.2292 41.8333 43.0625 42.25L43.125 41.9375C43.25 41.1042 43.3125 40.4583 43.3125 40C43.3125 37.5833 42.7083 35.3542 41.5 33.3125C40.3333 31.2708 38.7292 29.6667 36.6875 28.5C34.6458 27.2917 32.4167 26.6875 30 26.6875C27.5833 26.6875 25.3542 27.2917 23.3125 28.5C21.2708 29.6667 19.6458 31.2708 18.4375 33.3125C17.2708 35.3542 16.6875 37.5833 16.6875 40C16.6875 42.4167 17.2708 44.6458 18.4375 46.6875C19.6458 48.7292 21.2708 50.3542 23.3125 51.5625C25.3542 52.7292 27.5833 53.3125 30 53.3125C30.625 53.3125 31.375 53.2292 32.25 53.0625C31.875 52.4375 31.6042 51.6042 31.4375 50.5625ZM34.8125 42.8125L30.6875 40.375V33.3125H28.6875V41.3125L33.3125 44.125C33.6042 43.7917 34.1042 43.3542 34.8125 42.8125Z",
    fill: "#00ACC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedcourses);
export default __webpack_public_path__ + "static/media/finishedcourses.a082778e096e3d419290368e9aeb06f9.svg";
export { ForwardRef as ReactComponent };